/* Copyright (c) 2020-present CloudIO Inc */

import { ComponentSample, Item } from 'componentregistry';

const page: {
  card: Item<'Card'>;
  card1: Item<'Card'>;
  card2: Item<'Card'>;
  cardContent: Item<'CardContent'>;
  cardContent1: Item<'CardContent'>;
  cardContent2: Item<'CardContent'>;
  cardHeader: Item<'CardHeader'>;
  cardHeader1: Item<'CardHeader'>;
  cardHeader2: Item<'CardHeader'>;
  code: Item<'Code'>;
  code1: Item<'Code'>;
  code2: Item<'Code'>;
  flexItem: Item<'FlexItem'>;
  flexItem1: Item<'FlexItem'>;
  flexPanel: Item<'FlexPanel'>;
  mentionsAliasLocalDataStore: Item<'LocalDataStore'>;
  richTextEditor: Item<'RichTextEditor'>;
  root: Item<'Page'>;
  testAliasDataStoreReference: Item<'DataStoreReference'>;
  testAliasLocalDataStore: Item<'LocalDataStore'>;
  verticalSplitPanel: Item<'VerticalSplitPanel'>;
  verticalSplitPanel1: Item<'VerticalSplitPanel'>;
} = {
  card: {
    children: ['cardHeader', 'cardContent'],
    itemId: 'card',
    parent: 'verticalSplitPanel1',
    props: {
      border: false,
    },
    type: 'Card',
  },
  card1: {
    children: ['cardHeader1', 'cardContent1'],
    itemId: 'card1',
    parent: 'verticalSplitPanel',
    props: {
      border: false,
    },
    type: 'Card',
  },
  card2: {
    children: ['cardHeader2', 'cardContent2'],
    itemId: 'card2',
    parent: 'verticalSplitPanel1',
    props: {
      border: false,
    },
    type: 'Card',
  },
  cardContent: {
    children: ['code'],
    itemId: 'cardContent',
    parent: 'card',
    props: {
      noPadding: true,
    },
    type: 'CardContent',
  },
  cardContent1: {
    children: ['code1'],
    itemId: 'cardContent1',
    parent: 'card1',
    props: {
      noPadding: true,
    },
    type: 'CardContent',
  },
  cardContent2: {
    children: ['code2'],
    itemId: 'cardContent2',
    parent: 'card2',
    props: {
      noPadding: true,
    },
    type: 'CardContent',
  },
  cardHeader: {
    children: [],
    itemId: 'cardHeader',
    parent: 'card',
    props: {
      title: {
        type: 'text',
        value: 'JSON',
      },
    },
    type: 'CardHeader',
  },
  cardHeader1: {
    children: [],
    itemId: 'cardHeader1',
    parent: 'card1',
    props: {
      title: {
        type: 'text',
        value: 'HTML',
      },
    },
    type: 'CardHeader',
  },
  cardHeader2: {
    children: [],
    itemId: 'cardHeader2',
    parent: 'card2',
    props: {
      title: {
        type: 'text',
        value: 'Text',
      },
    },
    type: 'CardHeader',
  },
  code: {
    children: [],
    itemId: 'code',
    parent: 'cardContent',
    props: {
      insertable: {
        type: 'boolean',
        value: false,
      },
      language: 'json',
      updatable: {
        type: 'boolean',
        value: false,
      },
      viewAttribute: 'json',
    },
    type: 'Code',
  },
  code1: {
    children: [],
    itemId: 'code1',
    parent: 'cardContent1',
    props: {
      insertable: {
        type: 'boolean',
        value: false,
      },
      language: 'html',
      updatable: {
        type: 'boolean',
        value: false,
      },
      viewAttribute: 'html',
    },
    type: 'Code',
  },
  code2: {
    children: [],
    itemId: 'code2',
    parent: 'cardContent2',
    props: {
      insertable: {
        type: 'boolean',
        value: false,
      },
      language: 'text',
      updatable: {
        type: 'boolean',
        value: false,
      },
      viewAttribute: 'text',
    },
    type: 'Code',
  },
  flexItem: {
    children: ['richTextEditor'],
    itemId: 'flexItem',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexItem1: {
    children: ['verticalSplitPanel'],
    itemId: 'flexItem1',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['flexItem', 'flexItem1'],
    itemId: 'flexPanel',
    parent: 'testAliasDataStoreReference',
    props: {},
    type: 'FlexPanel',
  },
  mentionsAliasLocalDataStore: {
    children: [],
    itemId: 'mentionsAliasLocalDataStore',
    parent: 'root',
    props: {
      alias: 'mentionsAlias',
      data: 'code,name\nfirstName,First name\nlastName,Last Name\nfullName,Full Name\ndueDate,Due Date\namount,Amount\n',
      dataSource: 'mentions',
    },
    type: 'LocalDataStore',
  },
  richTextEditor: {
    children: [],
    itemId: 'richTextEditor',
    parent: 'flexItem',
    props: {
      htmlAttribute: 'html',
      label: { type: 'text', value: 'RTE' },
      labelAttribute: 'name',
      mentionDatasourceAlias: 'mentionsAlias',
      textAttribute: 'text',
      valueAttribute: 'code',
      viewAttribute: 'json',
    },
    type: 'RichTextEditor',
  },
  root: {
    children: [
      'testAliasLocalDataStore',
      'mentionsAliasLocalDataStore',
      'testAliasDataStoreReference',
    ],
    itemId: 'root',
    parent: 'root',
    props: {
      padding: {
        all: 0,
      },
      windowTitle: {
        type: 'text',
        value: 'RTE',
      },
    },
    type: 'Page',
  },
  testAliasDataStoreReference: {
    children: ['flexPanel'],
    itemId: 'testAliasDataStoreReference',
    parent: 'root',
    props: {
      alias: 'testAlias',
    },
    type: 'DataStoreReference',
  },
  testAliasLocalDataStore: {
    children: [],
    itemId: 'testAliasLocalDataStore',
    parent: 'root',
    props: {
      alias: 'testAlias',
      dataFormat: 'json',
      dataSource: 'test',
      jsonData:
        '[\n    {\n        "json": [\n            {\n                "type": "p",\n                "children": [\n                    {\n                        "text": "Hi "\n                    },\n                    {\n                        "type": "mention",\n                        "option": {\n                            "value": "fullName",\n                            "label": "Full Name"\n                        },\n                        "children": [\n                            {\n                                "text": ""\n                            }\n                        ]\n                    },\n                    {\n                        "text": ", "\n                    }\n                ]\n            },\n            {\n                "type": "p",\n                "children": [\n                    {\n                        "text": "Your total amount "\n                    },\n                    {\n                        "type": "mention",\n                        "option": {\n                            "value": "amount",\n                            "label": "Amount"\n                        },\n                        "children": [\n                            {\n                                "text": ""\n                            }\n                        ]\n                    },\n                    {\n                        "text": " is due by "\n                    },\n                    {\n                        "type": "mention",\n                        "option": {\n                            "value": "dueDate",\n                            "label": "Due Date"\n                        },\n                        "children": [\n                            {\n                                "text": ""\n                            }\n                        ]\n                    },\n                    {\n                        "text": ""\n                    }\n                ]\n            },\n            {\n                "type": "p",\n                "children": [\n                    {\n                        "text": "You can use base64 data as the URL for embedded images"\n                    }\n                ]\n            },\n            {\n                "type": "img",\n                "url": "data:image/png;base64,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",\n                "children": [\n                    {\n                        "text": ""\n                    }\n                ]\n            },\n            {\n                "type": "h1",\n                "children": [\n                    {\n                        "text": "Header 1"\n                    }\n                ]\n            },\n            {\n                "type": "h2",\n                "children": [\n                    {\n                        "text": "Header 2"\n                    }\n                ]\n            },\n            {\n                "type": "h3",\n                "children": [\n                    {\n                        "text": "Header 3"\n                    }\n                ]\n            },\n            {\n                "type": "p",\n                "children": [\n                    {\n                        "text": "Paragraph"\n                    }\n                ]\n            },\n            {\n                "type": "quote",\n                "children": [\n                    {\n                        "type": "p",\n                        "children": [\n                            {\n                                "text": "Quote"\n                            }\n                        ]\n                    }\n                ]\n            }\n        ],\n        "html": "<html/>",\n        "text": "text"\n    }\n]',
    },
    type: 'LocalDataStore',
  },
  verticalSplitPanel: {
    children: ['card1', 'verticalSplitPanel1'],
    itemId: 'verticalSplitPanel',
    parent: 'flexItem1',
    props: {},
    type: 'VerticalSplitPanel',
  },
  verticalSplitPanel1: {
    children: ['card2', 'card'],
    itemId: 'verticalSplitPanel1',
    parent: 'verticalSplitPanel',
    props: {},
    type: 'VerticalSplitPanel',
  },
};

export const helpRenders: ComponentSample<'RichTextEditor'>[] = [
  {
    title: 'Rich Text Editor',
    description:
      'Rich Text Editor with mentions. RTE is a WYSIWYG editor that allows you to format text and insert images, links, and other content. Mentions allows you to insert a placeholder in the content that can later be replaced on the server side with dynamic data. Make changes to the below content and observe the JSON, HTML & Text outputs.',
    page,
    exampleId: 'eg-01GK8A36HAXC9JGBTPYAGFMBY6',
    clearParentChildren: true,
    height: 580,
    hideProps: true,
    item: {
      children: [],
      itemId: 'richTextEditor',
      parent: 'flexItem',
      props: {
        htmlAttribute: 'html',
        label: { type: 'text', value: 'RTE' },
        labelAttribute: 'name',
        mentionDatasourceAlias: 'mentionsAlias',
        textAttribute: 'text',
        valueAttribute: 'code',
        viewAttribute: 'json',
      },
      type: 'RichTextEditor',
    },
  },
];
